import React, { useEffect } from 'react';
import Avatar from '../../common/Avatar';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import { PARTICIPATING_TYPE } from '../../../constants/avatarType.constants';

import './scss/accepted.dependents.scss';

const AcceptedDependents = ({ challenge, toggleAccepted }) => {
  const count = challenge.repos.accepted_dependent_count;
  const dependents = challenge.repos.all_accepted_dependents
    ? challenge.repos.all_accepted_dependents
    : [];
  return (
    <div
      className={`accepted-dependents-section ${
        toggleAccepted ? 'toggle-show' : 'toggle-hide'
      }`}
    >
      {count === 0 ? (
        <div className="avatars-container empty"></div>
      ) : (
        <div className="avatars-container">
          {dependents &&
            dependents.map((dependent) => {
              const profileURL = getUserProfileUrl(dependent);
              return (
                <Avatar
                  userProfileUrl={profileURL}
                  type={PARTICIPATING_TYPE}
                  user={dependent}
                  key={dependent.id}
                />
              );
            })}
        </div>
      )}
    </div>
  );
};

export default AcceptedDependents;
